<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required, minValue, maxValue } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      authToken: '',
      pollingInterval: 60,
      syncOrders: true,
      syncItems: true,
      syncCalls: true,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    authToken: { required },
    pollingInterval: {
      required,
      minValue: minValue(30),
      maxValue: maxValue(300),
    },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const rozetkaChannel = await this.$store.dispatch('inboxes/createChannel', {
          channel: {
            type: 'rozetka',
            auth_token: this.authToken,
            polling_interval: this.pollingInterval,
            sync_orders: this.syncOrders,
            sync_items: this.syncItems,
            sync_calls: this.syncCalls,
          },
        });

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: rozetkaChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.ROZETKA_CHANNEL.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.ROZETKA_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.ROZETKA_CHANNEL.DESC')"
    />
    <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.authToken.$error }">
          {{ $t('INBOX_MGMT.ADD.ROZETKA_CHANNEL.AUTH_TOKEN.LABEL') }}
          <input
            v-model="authToken"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.ROZETKA_CHANNEL.AUTH_TOKEN.PLACEHOLDER')"
            @blur="v$.authToken.$touch"
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.ROZETKA_CHANNEL.AUTH_TOKEN.SUBTITLE') }}
        </p>
      </div>

      <div class="flex-shrink-0 flex-grow-0 mt-4">
        <label :class="{ error: v$.pollingInterval.$error }">
          {{ $t('INBOX_MGMT.ADD.ROZETKA_CHANNEL.POLLING_INTERVAL.LABEL') }}
          <input
            v-model.number="pollingInterval"
            type="number"
            min="30"
            max="300"
            :placeholder="$t('INBOX_MGMT.ADD.ROZETKA_CHANNEL.POLLING_INTERVAL.PLACEHOLDER')"
            @blur="v$.pollingInterval.$touch"
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.ROZETKA_CHANNEL.POLLING_INTERVAL.SUBTITLE') }}
        </p>
      </div>

      <div class="flex-shrink-0 flex-grow-0 mt-4">
        <p class="font-medium text-sm mb-2">
          {{ $t('INBOX_MGMT.ADD.ROZETKA_CHANNEL.SYNC_OPTIONS.LABEL') }}
        </p>
        <label class="flex items-center gap-2 mb-2">
          <input
            v-model="syncOrders"
            type="checkbox"
            class="w-4 h-4"
          />
          {{ $t('INBOX_MGMT.ADD.ROZETKA_CHANNEL.SYNC_OPTIONS.ORDERS') }}
        </label>
        <label class="flex items-center gap-2 mb-2">
          <input
            v-model="syncItems"
            type="checkbox"
            class="w-4 h-4"
          />
          {{ $t('INBOX_MGMT.ADD.ROZETKA_CHANNEL.SYNC_OPTIONS.ITEMS') }}
        </label>
        <label class="flex items-center gap-2">
          <input
            v-model="syncCalls"
            type="checkbox"
            class="w-4 h-4"
          />
          {{ $t('INBOX_MGMT.ADD.ROZETKA_CHANNEL.SYNC_OPTIONS.CALLS') }}
        </label>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.ROZETKA_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>

